// extracted by mini-css-extract-plugin
export default {"title":"PropertiesHeader_title__VcPLf"};